import * as React from 'react';
import { clsx } from 'clsx';
import * as styles from './styles.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function IconButton(_ref) {
  var Icon = _ref.Icon,
    label = _ref.label,
    disabled = _ref.disabled,
    active = _ref.active,
    onClick = _ref.onClick;
  var color = React.useMemo(function () {
    if (disabled) {
      return 'icon-primary-disabled';
    }
    if (active) {
      return 'icon-secondary-default';
    }
    return 'icon-main-disabled';
  }, [active, disabled]);
  return /*#__PURE__*/_jsxs("button", {
    "data-testid": "IconButton",
    disabled: disabled,
    className: clsx(styles['button'], active && styles['button--active']),
    onClick: onClick,
    children: [/*#__PURE__*/_jsx(Icon, {
      color: color
    }), label !== undefined && /*#__PURE__*/_jsx("span", {
      className: styles['label'],
      children: label
    })]
  });
}